// import logotipo from '../../../../../assets/logo.png'
import View from '../../../../../components/configPdf/View'
import Text from '../../../../../components/configPdf/Text'
import { Page, Document, PDFViewer } from '@react-pdf/renderer'
import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { requestDefaulAuth } from '../../../../../http/httpRequest'
import { formatDateNumberWithTime } from '../../../../../utils/dateFormat'
import { JoinStrings } from '../../../../../utils/dataValidations'
import config from "../../../../../config.json";

const SECTION_ORDER = [
  'CAJA CENTRAL',
  'GARANTÍAS CENTRAL',
  'BANCOS CENTRAL',
  'GARANTÍAS EN BANCOS CENTRAL',
]

const CuadernoBoletaPdf = () => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const dipatch = useDispatch()
  const user = useSelector(state => state.login.userDetail)

  const getData = async () => {
    setLoading(true)
    await requestDefaulAuth(
      'get',
      `/cuaderno/${params.cuaderno_id}`,
      null,
      setData,
      dipatch
    )
    setLoading(false)
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.cuaderno_id])

  const toNumber = (value) => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0

    if (typeof value === 'string') {
      const normalized = value
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/[^\d.-]/g, '')

      const n = Number(normalized)
      return Number.isFinite(n) ? n : 0
    }

    return 0
  }

  const formatBs = (value) =>
    toNumber(value).toLocaleString('es-BO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

  const truncate = (text, max = 22) => {
    const value = String(text || '')
    return value.length > max ? `${value.slice(0, max - 1)}…` : value
  }

  const normalizeTipo = (tipo) =>
    String(tipo || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const resolveSectionTitle = (tipo) => {
    const normalized = normalizeTipo(tipo)

    if (normalized === 'caja' || normalized === 'gasto') {
      return 'CAJA CENTRAL'
    }

    if (normalized === 'garantia' || normalized === 'garantia_efectivo') {
      return 'GARANTÍAS CENTRAL'
    }

    if (normalized === 'banco') {
      return 'BANCOS CENTRAL'
    }

    if (
      normalized === 'garantia en banco' ||
      normalized === 'garantia_en_banco' ||
      normalized === 'garantia banco' ||
      normalized === 'garantia_banco' ||
      normalized === 'garantia_bancos'
    ) {
      return 'GARANTÍAS EN BANCOS CENTRAL'
    }

    return null
  }

  const resolveItemLabel = (item) => {
    const normalized = normalizeTipo(item?.tipo)

    if (normalized === 'gasto') {
      return 'GASTO'
    }

    return (
      item?.Producto?.nombre ||
      item?.producto_nombre ||
      item?.nombre ||
      item?.label ||
      'SIN NOMBRE'
    )
  }

  const resolveSignedAmount = (item) => {
    const normalized = normalizeTipo(item?.tipo)
    const amount = toNumber(item?.monto_total)

    if (normalized === 'gasto') {
      return -Math.abs(amount)
    }

    return amount
  }

  const DataLabels = [
    { label: 'SR.:', value: JoinStrings([data.nombres, data.apellido_paterno, data.apellido_materno], ' ') },
    { label: 'COD. VEND.:', value: data?.usuario_cod },
    { label: 'CUADERNO:', value: data.codigo },
    { label: 'FECHA:', value: formatDateNumberWithTime(new Date()) },
  ]

  const groupedSections = useMemo(() => {
    const grouped = (data?.Cuaderno_efectivos || []).reduce((acc, item) => {
      const sectionTitle = resolveSectionTitle(item?.tipo)
      const label = resolveItemLabel(item)
      const amount = resolveSignedAmount(item)

      if (!sectionTitle || !label || amount === 0) return acc

      if (!acc[sectionTitle]) {
        acc[sectionTitle] = {}
      }

      if (!acc[sectionTitle][label]) {
        acc[sectionTitle][label] = 0
      }

      acc[sectionTitle][label] += amount

      return acc
    }, {})

    return SECTION_ORDER.map((title) => {
      const itemsObject = grouped[title] || {}

      const items = Object.entries(itemsObject)
        .map(([label, amount]) => ({
          label,
          amount: toNumber(amount),
        }))
        .filter((item) => item.amount !== 0)

      const total = items.reduce((acc, item) => acc + item.amount, 0)

      return {
        title,
        items,
        total,
      }
    }).filter((section) => section.items.length > 0)
  }, [data])

  const grandTotal = useMemo(() => {
    return groupedSections.reduce((acc, section) => acc + section.total, 0)
  }, [groupedSections])

  const ownerName = JoinStrings(
    [data.nombres, data.apellido_paterno, data.apellido_materno],
    ' '
  )?.toUpperCase()

  const generatedByName = JoinStrings(
    [user.nombres, user.apellido_paterno, user.apellido_materno],
    ' '
  )?.toUpperCase() 

  const MyDoc = (
    <Document>
      <Page size={{ width: 226.77, height: 'auto' }} style={{ padding: '3px' }}>
        <View alignItems='flex-start'>
          <View
            width='100%'
            flexDirection='column'
            margin='20px 0px'
          >
            <View margin='auto'>
              <Text c2 bold fontSize='8px'>DISTRIBUIDORA</Text>
            </View>
            <View margin='auto'>
              <Text c2 bold fontSize='8px'>***{config.simpleName?.toUpperCase() ?? ''}***</Text>
            </View>
            <View margin='auto'>
              <Text c2 bold fontSize='8px'>LA PAZ - BOLIVIA</Text>
            </View>

            <View margin='5px'>
              <Text c2 bold fontSize='8px'></Text>
            </View>

            <View margin='auto'>
              <Text c2 bold fontSize='12px' style={{ letterSpacing: '8px' }}>RECIBO</Text>
            </View>

            <LinerSpacing />

            {/* <View margin='3px 0px 0px 0px'>
              <View justifyContent='flex-end' width='50%'>
                <Text c2 bold fontSize='8px' textAlign='right'>RECIBO</Text>
              </View>
              <View margin='auto' width='50%'>
                <Text c2 bold fontSize='8px'>No {data.codigo?.replace(/\D/g, '')}</Text>
              </View>
            </View>

            <LinerSpacing /> */}

            <View>
              <View flexDirection='column'>
                {
                  DataLabels.map((i, idx) => (
                    <View key={idx}>
                      <View justifyContent='flex-end' width='30%'>
                        <Text c2 bold fontSize='8px' textAlign='right'>
                          {i.label?.toUpperCase()}
                        </Text>
                      </View>
                      <View margin='auto' width='70%'>
                        <Text c2 bold fontSize='8px'>
                          {String(i.value ?? '').toUpperCase()}
                        </Text>
                      </View>
                    </View>
                  ))
                }
              </View>
            </View>

            <LinerSpacing />

            <View>
              <View flexDirection='column' margin='0px 5px'>
                {
                  groupedSections.map((section, idx) => (
                    <View key={idx} flexDirection='column' margin='0px 0px 6px 0px'>
                      <View margin='2px 0px'>
                        <Text c2 bold fontSize='8px' textAlign='left'>
                          {section.title}
                        </Text>
                      </View>

                      {
                        section.items.map((item, subIdx) => (
                          <View key={subIdx}>
                            <View width='65%'>
                              <Text c2 bold fontSize='8px' textAlign='left'>
                                {truncate(item.label).toUpperCase()}
                              </Text>
                            </View>
                            <View width='35%'>
                              <Text c2 bold fontSize='8px' textAlign='right'>
                                {formatBs(item.amount)}
                              </Text>
                            </View>
                          </View>
                        ))
                      }
                      <LinerSpacing />
                      <View margin='1px 0px'>
                        <View width='65%'>
                          <Text c2 bold fontSize='8px' textAlign='left'>
                            TOTAL
                          </Text>
                        </View>
                        <View width='35%'>
                          <Text c2 bold fontSize='8px' textAlign='right'>
                            {formatBs(section.total)}
                          </Text>
                        </View>
                      </View>
                    </View>
                  ))
                }
              </View>
            </View>


            {/* <View>
            <LinerSpacing />
              <View margin='0px 5px'>
                <View width='65%'>
                  <Text c2 bold fontSize='8px' textAlign='left'>
                    TOTAL
                  </Text>
                </View>
                <View width='35%'>
                  <Text c2 bold fontSize='8px' textAlign='right'>
                    {formatBs(grandTotal)}
                  </Text>
                </View>
              </View>
            </View>

            <View>
            <LinerSpacing />
              <Text c2 bold fontSize='8px' textAlign='right' margin='0px 5px'>
                GENERADO POR: {(JoinStrings([user.nombres, user.apellido_paterno, user.apellido_materno], ' '))?.toUpperCase()}
              </Text>
            </View> */}

            <LinerSpacing />
            <View margin='8px'></View>

            <View margin='4px 0px 0px 0px' justifyContent='space-between'>
              <View width='45%' flexDirection='column' alignItems='center'>
                <Text c2 bold fontSize='8px' textAlign='center'>
                  ------------------------
                </Text>
                <Text c2 bold fontSize='8px' textAlign='center'>
                  {generatedByName}
                </Text>
              </View>

              <View width='45%' flexDirection='column' alignItems='center'>
                <Text c2 bold fontSize='8px' textAlign='center'>
                  ------------------------
                </Text>
                <Text c2 bold fontSize='8px' textAlign='center'>
                  {ownerName}
                </Text>
              </View>
            </View>

            <View margin='5px'></View>

            <View margin='auto'>
              <Text c2 bold fontSize='8px'>***{config.simpleName?.toUpperCase() ?? ''}***</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  )

  return (
    loading ?
      <div className='mx-16 my-12'>
        <div>
          <svg aria-hidden='true' className='inline w-14 h-14 text-gray-200 animate-spin dark:text-gray-500 dark:fill-yellow-500 fill-yellow-600' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor' />
            <path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='currentFill' />
          </svg>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
      :
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
  )
}

export default CuadernoBoletaPdf

const LinerSpacing = () => {
  return (
    <View margin='auto'>
      <Text c2 bold fontSize='12px' style={{ letterSpacing: '2px' }}>
        ----------------------------------
      </Text>
    </View>
  )
}